export default {
    title: 'Від оренди квартири до покупки цуценя',
    description: 'На сервісі представлено 12 об’ємних категорій',
    stepCategoryHobby: 'Хоббі, відпочинок та спорт',
    stepCategoryHouse: 'Дім і сад',
    stepCategoryElectronica: 'Електроніка',
    stepCategoryBiznes: 'Бізнес та послуги',
    stepCategoryChildren: 'Дитячий світ',
    stepCategoryAnimals: 'Тварини',
}